export default __webpack_public_path__ + "static/media/emptyphoto.4f89eff7.png";